export const ENTITY_DOCUMENT_TYPE = {
  ENTITY_DOCUMENT: 'ENTITY_DOCUMENT',
  TIMELINE_NOTE_DOCUMENT: 'TIMELINE_NOTE_DOCUMENT',
  PRESALE_REQUEST_DOCUMENT: 'PRESALE_REQUEST_DOCUMENT',
  CONTRACT_REQUEST_DOCUMENT: 'CONTRACT_REQUEST_DOCUMENT',
  ACTIVITY_DOCUMENT: 'ACTIVITY_DOCUMENT',
};
